export type MedicalConditionOption = {
  id: string;
  name: string;
  /** UI-only: free-text conditions are sent as the entered string, not this id */
  freeText?: true;
};

export const MEDICAL_CONDITION_OTHER_ID = 'other';

/** Predefined conditions: UI label → API id. */
export const MEDICAL_CONDITIONS_API_OPTIONS: readonly MedicalConditionOption[] = [
  { id: 'diabetes', name: 'Diabetes' },
  { id: 'prediabetes', name: 'Prediabetes' },
  { id: 'thyroid', name: 'Thyroid disorder' },
  { id: 'pcos', name: 'PCOS' },
  { id: 'insulin_resistance', name: 'Insulin resistance' },
  { id: 'hypertension', name: 'High blood pressure' },
  { id: 'hyperlipidemia', name: 'High cholesterol' },
  { id: 'heart_disease', name: 'Heart disease' },
  { id: 'kidney_disease', name: 'Kidney disease' },
  { id: 'fatty_liver', name: 'Fatty liver (NAFLD)' },
  { id: 'ibs', name: 'Irritable Bowel Syndrome IBS' },
  { id: 'ibd', name: 'Inflammatory Bowel Disease IBD' },
  { id: 'coeliac', name: 'Coeliac disease' },
  { id: 'mental_health', name: 'Mental health condition' },
  { id: 'eating_disorder', name: 'Eating Disorder (Current/ Past)' },
] as const;

/** Includes UI-only Other entry for labels; custom values are sent as free text. */
export const MEDICAL_CONDITIONS_OPTIONS: readonly MedicalConditionOption[] = [
  ...MEDICAL_CONDITIONS_API_OPTIONS,
  { id: 'other', name: 'Other', freeText: true },
];

/** Fallback subtypes if GET /clients/preference-options has not loaded yet. */
export const MEDICAL_CONDITION_SUBTYPE_OPTIONS: Readonly<
  Record<string, ReadonlyArray<{ id: string; name: string; value: string }>>
> = {
  diabetes: [
    { id: 'Type 1', name: 'Type 1', value: 'Type 1' },
    { id: 'Type 2', name: 'Type 2', value: 'Type 2' },
    { id: 'LADA', name: 'LADA', value: 'LADA' },
    { id: 'Gestational', name: 'Gestational', value: 'Gestational' },
    { id: 'Prediabetes', name: 'Prediabetes', value: 'Prediabetes' },
    { id: 'Not sure', name: 'Not sure', value: 'Not sure' },
  ],
  thyroid: [
    { id: 'Underactive (hypothyroid)', name: 'Underactive (hypothyroid)', value: 'Underactive (hypothyroid)' },
    { id: 'Overactive (hyperthyroid)', name: 'Overactive (hyperthyroid)', value: 'Overactive (hyperthyroid)' },
    { id: "Hashimoto's", name: "Hashimoto's", value: "Hashimoto's" },
    { id: 'Graves', name: 'Graves', value: 'Graves' },
    { id: 'Not sure', name: 'Not sure', value: 'Not sure' },
  ],
};

export const LEGACY_MEDICAL_CONDITION_IDS: Readonly<Record<string, string>> = {
  celiac: 'coeliac',
  liver_disease: 'fatty_liver',
  thyroid_disorders: 'thyroid',
  hypertension: 'hypertension',
};
